import { SimilarMention as SimilarMentionType } from "@/types/Mention";
import { Button } from "@components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@components/ui/collapsible";
import { Trans } from "@lingui/react/macro";
import { ChevronDownIcon } from "lucide-react";
import SimilarMention from "./SimilarMention";
import { plural } from "@lingui/core/macro";

type SimilarMentionsProps = {
  similarMentions: SimilarMentionType[];
};

export default function SimilarMentions({
  similarMentions,
}: SimilarMentionsProps) {
  // Helpers
  const similarMentionsCount = similarMentions.length;

  return (
    <Collapsible className="group/similar">
      <CollapsibleTrigger
        render={
          <Button
            data-testid="similar-mentions"
            size="sm"
            variant="link-muted"
            className="h-fit -mx-2"
          />
        }
      >
        <Trans>
          Liknande{" "}
          {plural(similarMentionsCount, {
            one: "omnämnande",
            other: "omnämnanden",
          })}{" "}
          i {similarMentionsCount}{" "}
          {plural(similarMentionsCount, {
            one: "annan källa",
            other: "andra källor",
          })}
        </Trans>
        <ChevronDownIcon className="group-data-open/similar:-rotate-180" />
      </CollapsibleTrigger>
      <CollapsibleContent className="flex flex-col gap-2 pt-2">
        {similarMentions.map((similarMention) => (
          <SimilarMention
            key={similarMention.uuid}
            similarMention={similarMention}
          />
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
}
